import { Component, OnInit } from '@angular/core';
import {NgbModal, ModalDismissReasons,NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import { MasterService } from '../../services/index';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-accmaster',
  templateUrl: './accmaster.component.html',
  styleUrls: ['./accmaster.component.scss'],
  providers:[MasterService]
})
export class AccmasterComponent implements OnInit {
  tab=1;
  closeResult = '';
  modalOptions:NgbModalOptions;
  private modalRef: NgbModalRef;
  Accountshead: any=[];
  objacc:any={};
  astatus=[{name:'ACTIVE'},{name:'INACTIVE'}];
  cat:any[];
  Category: any=[];
  objcat:any={};
  feeQuota: any=[];
  objfeeqta:any={};
  installment: any=[];
  objinsta:any={};
  paymentop: any=[];
  objpayop:any={};
  Modeot: any=[];
  objmot:any={};

  constructor(private http: HttpClient,private modalService: NgbModal,private mservice: MasterService) { }

  ngOnInit(): void {
    this.masacchead('all');
    this.masacccat();
    //this.mascategory();
    //this.masfeequta();
    //this.masinstallment();
    //this.maspayop(); 
    //this.masmot();
  
  }
  masacccat() {
    debugger
    this.mservice.masacccat()
        .subscribe(
        resultArray => {
            console.log('getacccategory', resultArray);
            this.cat = resultArray;
           
        },
        error => console.log("Error :: " + error)
        )
  }

  mascategory() {
    debugger
    this.mservice.masacccat()
        .subscribe(
        resultArray => {
            console.log('getacccategory', resultArray);
            this.Category = resultArray;
           
        },
        error => console.log("Error :: " + error)
        )
  }

  masacchead(status) {
    debugger
    this.mservice.masacchead(status)
        .subscribe(
        resultArray => {
            console.log('getacch', resultArray);
            this.Accountshead = resultArray;
           
        },
        error => console.log("Error :: " + error)
        )
  }

  openacch(content,objdata,cmd) {
    if(cmd=='insert')
    {
      this.objacc={};
     
      
      this.objacc.acid=0;
     
      this.objacc.oprtag='insert';
     

    }

    else if(cmd=='update')
    {
      
      this.objacc=objdata;
      this.objacc.oprtag='update';
    
    }
    
    this.modalOptions = {
      backdrop:'static',
      backdropClass:'customBackdrop',
      size:'sm'
     
     
    }
    this.modalRef=this.modalService.open(content,this.modalOptions);
    
    this.modalRef.result.then((result) => {
   
         
      }, (reason) => {
          
      });
  }

  saveacch(){
    console.log('savedetailsacch',this.objacc);
    this.mservice.saveaachdetails(this.objacc)
.subscribe(result => {
   alert(result.message);
   
if(result.status=='success')
{
  let localmodref=this.modalRef;
localmodref.close();
//this.Refreshsummary();
this.masacchead('all');

}


else{


}
   

  
    
}, error => alert('error in connection')
);
  }


  Deleteahdetails(objacc) {
  
    if(confirm("Are you sure? you wan't to delete. "))
    {
    // var acid = objacc.acid;
    var clssubdata = { acid:  objacc.acid, accd: '', oprtag:'delete',acnm:'' };
  
    console.log('save-model', clssubdata);
    this.mservice.saveaachdetails(clssubdata)
        .subscribe(resultArray => {
            console.log('ret-save', resultArray);
            
            alert (resultArray.message);
            if(resultArray.status=='success')
            {
              
             this.masacchead('all');
            }
          
        }, error =>
            alert('error in connection')
        );

  }
}



opencat(content,objdata,cmd) {
  if(cmd=='insert')
  {
    this.objcat={};
   
    
    this.objcat.accatid=0;
   
    this.objcat.oprtag='insert';
   

  }

  else if(cmd=='update')
  {
    this.objcat=objdata;
    this.objcat.oprtag='update';
  }
  
  this.modalOptions = {
    backdrop:'static',
    backdropClass:'customBackdrop',
    size:'sm'
   
   
  }
  this.modalRef=this.modalService.open(content,this.modalOptions);
  
  this.modalRef.result.then((result) => {
 
       
    }, (reason) => {
        
    });
}

savecatdetails(){
  console.log('savedetails',this.objcat);
  this.mservice.savecatadtls(this.objcat)
.subscribe(result => {
 alert(result.message);
 
if(result.status=='success')
{
let localmodref=this.modalRef;
localmodref.close();
//this.Refreshsummary();
this.mascategory();

}


else{


}
 


  
}, error => alert('error in connection')
);
}

Deletecatdetails(objcat) {

  if(confirm("Are you sure? you wan't to delete. "))
  {
  var accatid = objcat.accatid;
  var clssubdata = { accatid:  objcat.accatid, accatcd: '', oprtag:'delete',accatnm:'' };

  console.log('save-model', clssubdata);
  this.mservice.savecatadtls(clssubdata)
      .subscribe(resultArray => {
          console.log('ret-save', resultArray);
          
          alert (resultArray.message);
          if(resultArray.status=='success')
          {
            
           this.mascategory();
          }
        
      }, error =>
          alert('error in connection')
      );

}
}

masfeequta() {
  this.mservice.masfeequta()
      .subscribe(
      resultArray => {
          console.log('getfeeqta', resultArray);
          this.feeQuota = resultArray;
         
      },
      error => console.log("Error :: " + error)
      )
}


openfeq(content,objdata,cmd) {
  if(cmd=='insert')
  {
    this.objfeeqta={};
   
    
    this.objfeeqta.feqtId=0;
   
    this.objfeeqta.oprtag='insert';
   

  }

  else if(cmd=='update')
  {
    this.objfeeqta=objdata;
    this.objfeeqta.oprtag='update';
  }
  
  this.modalOptions = {
    backdrop:'static',
    backdropClass:'customBackdrop',
    size:'sm'
   
   
  }
  this.modalRef=this.modalService.open(content,this.modalOptions);
  
  this.modalRef.result.then((result) => {
 
       
    }, (reason) => {
        
    });
}


savefeq(){
  console.log('savedetailsfeq',this.objfeeqta);
  this.mservice.savefeqdetails(this.objfeeqta)
.subscribe(result => {
 alert(result.message);
 
if(result.status=='success')
{
let localmodref=this.modalRef;
localmodref.close();
//this.Refreshsummary();
this.masfeequta();

}


else{


}
 


  
}, error => alert('error in connection')
);
}

Deletefqdetails(objfeeqta) {

  if(confirm("Are you sure? you wan't to delete. "))
  {
  var feqtId = objfeeqta.feqtId;
  var clssubdata = { feqtId:  objfeeqta.feqtId, feqtcd: '', oprtag:'delete',feqtnm:'' };

  console.log('save-model', clssubdata);
  this.mservice.savefeqdetails(clssubdata)
      .subscribe(resultArray => {
          console.log('ret-save', resultArray);
          
          alert (resultArray.message);
          if(resultArray.status=='success')
          {
            
           this.masfeequta();
          }
        
      }, error =>
          alert('error in connection')
      );

}
}


masinstallment() {
  this.mservice.masinstallment()
      .subscribe(
      resultArray => {
          console.log('getinsta', resultArray);
          this.installment = resultArray;
         
      },
      error => console.log("Error :: " + error)
      )
}


openinsta(content,objdata,cmd) {
  if(cmd=='insert')
  {
    this.objinsta={};
   
    
    this.objinsta.insid=0;
   
    this.objinsta.oprtag='insert';
   

  }

  else if(cmd=='update')
  {
    this.objinsta=objdata;
    this.objinsta.oprtag='update';
  }
  
  this.modalOptions = {
    backdrop:'static',
    backdropClass:'customBackdrop',
    size:'sm'
   
   
  }
  this.modalRef=this.modalService.open(content,this.modalOptions);
  
  this.modalRef.result.then((result) => {
 
       
    }, (reason) => {
        
    });
}

saveinstadetails(){
  console.log('savedetails',this.objinsta);
  this.mservice.saveinstadtls(this.objinsta)
.subscribe(result => {
 alert(result.message);
 
if(result.status=='success')
{
let localmodref=this.modalRef;
localmodref.close();
//this.Refreshsummary();
this.masinstallment();

}


else{


}
 


  
}, error => alert('error in connection')
);
}

Deleteindetails(objinsta) {

  if(confirm("Are you sure? you wan't to delete. "))
  {
  var insid = objinsta.insid;
  var clssubdata = { insid:  objinsta.insid, inscd: '', oprtag:'delete',insnm:'' };

  console.log('save-model', clssubdata);
  this.mservice.saveinstadtls(clssubdata)
      .subscribe(resultArray => {
          console.log('ret-save', resultArray);
          
          alert (resultArray.message);
          if(resultArray.status=='success')
          {
            
           this.masinstallment();
          }
        
      }, error =>
          alert('error in connection')
      );

}
}

maspayop() {
  this.mservice.maspayop()
      .subscribe(
      resultArray => {
          console.log('getpayop', resultArray);
          this.paymentop = resultArray;
         
      },
      error => console.log("Error :: " + error)
      )
}


openpayop(content,objdata,cmd) {
  if(cmd=='insert')
  {
    this.objpayop={};
   
    
    this.objpayop.payoptid=0;
   
    this.objpayop.oprtag='insert';
   

  }

  else if(cmd=='update')
  {
    this.objpayop=objdata;
    this.objpayop.oprtag='update';
  }
  
  this.modalOptions = {
    backdrop:'static',
    backdropClass:'customBackdrop',
    size:'sm'
   
   
  }
  this.modalRef=this.modalService.open(content,this.modalOptions);
  
  this.modalRef.result.then((result) => {
 
       
    }, (reason) => {
        
    });
}

savepayopdetails(){
  console.log('savedetails',this.objpayop);
  this.mservice.savepayop(this.objpayop)
.subscribe(result => {
 alert(result.message);
 
if(result.status=='success')
{
let localmodref=this.modalRef;
localmodref.close();
//this.Refreshsummary();
this.maspayop();

}


else{


}
 


  
}, error => alert('error in connection')
);
}


Deletepayopdetails(objpayop) {

  if(confirm("Are you sure? you wan't to delete. "))
  {
  var payoptid = objpayop.payoptid;
  var clssubdata = { payoptid:  objpayop.payoptid, payoptcd: '', oprtag:'delete',payoptnm:'' };

  console.log('save-model', clssubdata);
  this.mservice.savepayop(clssubdata)
      .subscribe(resultArray => {
          console.log('ret-save', resultArray);
          
          alert (resultArray.message);
          if(resultArray.status=='success')
          {
            
           this.maspayop();
          }
        
      }, error =>
          alert('error in connection')
      );

}
}


masmot() {
  this.mservice.masmotransaction()
      .subscribe(
      resultArray => {
          console.log('getmot', resultArray);
          this.Modeot = resultArray;
         
      },
      error => console.log("Error :: " + error)
      )
}



openmot(content,objdata,cmd) {
  if(cmd=='insert')
  {
    this.objmot={};
   
    
    this.objmot.motid=0;
   
    this.objmot.oprtag='insert';
   

  }

  else if(cmd=='update')
  {
    this.objmot=objdata;
    this.objmot.oprtag='update';
  }
  
  this.modalOptions = {
    backdrop:'static',
    backdropClass:'customBackdrop',
    size:'sm'
   
   
  }
  this.modalRef=this.modalService.open(content,this.modalOptions);
  
  this.modalRef.result.then((result) => {
 
       
    }, (reason) => {
        
    });
}

savemotdetails(){
  console.log('savedetails',this.objmot);
  this.mservice.savemot(this.objmot)
.subscribe(result => {
 alert(result.message);
 
if(result.status=='success')
{
let localmodref=this.modalRef;
localmodref.close();
//this.Refreshsummary();
this.masmot();

}


else{


}
 


  
}, error => alert('error in connection')
);
}


Deletemotdetails(objmot) {

  if(confirm("Are you sure? you wan't to delete. "))
  {
  var motid = objmot.motid;
  var clssubdata = { motid:  objmot.motid, motnm: '', oprtag:'delete',motstatus:'' };

  console.log('save-model', clssubdata);
  this.mservice.savepayop(clssubdata)
      .subscribe(resultArray => {
          console.log('ret-save', resultArray);
          
          alert (resultArray.message);
          if(resultArray.status=='success')
          {
            
           this.masmot();
          }
        
      }, error =>
          alert('error in connection')
      );

}
}

}
